/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { useTranslation } from "react-i18next";

//custom libraries
import { PASSWORD_EXPIRED_ERRORS } from "../constants/error";
import { Message, MessageType } from "../constants/message";

export const useError = () => {
  const { t, i18n } = useTranslation();
  const transformError = (err: any): Message => {
    if (err.isAxiosError) {
      const errorResponse = err.response;
      if (errorResponse && errorResponse.data && errorResponse.data.errors) {
        const error = errorResponse.data.errors[0];
        const errorKey = error.errorKey || "";
        const errorCode = error.errorCode;
        const errorParameters =
          typeof error.errorParameters === "string"
            ? error.errorParameters.split(",")
            : error.errorParameters
            ? error.errorParameters
            : [];
        const _messageKey =
          (errorCode && errorCode !== errorKey && errorKey + "_" + errorCode) ||
          errorKey;

        const message = i18n.exists(`Error.${_messageKey}`)
          ? t(`Error.${_messageKey}`, { ...errorParameters })
          : i18n.exists(`Error._${errorCode}`)
          ? t(`Error._${errorCode}`, { ...errorParameters })
          : error.errorMessage || error.message;
        const errorRes: Message = { message, type: MessageType.ERROR };
        if (
          (errorCode && PASSWORD_EXPIRED_ERRORS.includes(errorCode)) ||
          (errorKey && PASSWORD_EXPIRED_ERRORS.includes(errorKey))
        ) {
          errorRes.passwordExpired = true;
        } else {
          errorRes.passwordExpired = false;
        }
        return errorRes;
      }
    }
    return {
      message: err.message || err.toLocaleString(),
      type: MessageType.ERROR,
    };
  };

  return {
    transformError,
  };
};
